import React, { MouseEvent } from "react";
import { Sync, RemoveCircleOutline } from "@mui/icons-material";

import { StreamingIntegration } from "store/types";
import { formattedDate } from "tools";
import store from "store";
import { ACTION_FIELD_PROPERTY } from "consts";
import { ActionButtonsWrapper } from "components/ui";

const rotateKeyModal = (integration: StreamingIntegration) => {
  const keys = store?.streamingIntegrations.getKeysForIntegration(integration.id);
  if (!keys || keys.length === 0) return;

  const key = keys[0];

  store?.ui.openConfirmModal({
    title: "Are you sure you want to rotate this Streaming API Key?",
    confirmText: "Rotate",
    onConfirm: async () => {
      await store.streamingIntegrations.rotateKey(integration.id, key.id);
    },
  });
};

const deleteIntegrationModal = (integration: StreamingIntegration) => {
  store?.ui.openConfirmModal({
    title: "Are you sure you want to delete this Streaming Integration?",
    confirmText: "Delete",
    onConfirm: async () => {
      await store.streamingIntegrations.deleteIntegration(integration.id);
    },
  });
};

export const streamingIntegrationFields = [
  { name: "Name", property: "name" },
  {
    name: "Key",
    property: "key_id",
    render: (integration: StreamingIntegration) => {
      const keys = store?.streamingIntegrations.getKeysForIntegration(integration.id);
      return keys?.[0]?.id || "";
    },
  },
  {
    name: "Created date",
    property: "created_at",
    render: (integration: StreamingIntegration) => formattedDate(integration.created_at),
  },
  {
    name: "Created by",
    property: "created_by_user_id",
    render: (integration: StreamingIntegration) =>
      store?.users.getUserNameById(integration.created_by_user_id) || integration.created_by_user_id || "",
  },
  {
    property: ACTION_FIELD_PROPERTY,
    render: (item: StreamingIntegration) => (
      <ActionButtonsWrapper
        item={item}
        inTable
        buttons={[
          {
            icon: Sync,
            text: "Rotate Key",
            onClick: (e: MouseEvent<HTMLElement>, integration: StreamingIntegration) => rotateKeyModal(integration),
          },
          {
            icon: RemoveCircleOutline,
            text: "Remove",
            variant: "text",
            onClick: (e: MouseEvent<HTMLElement>, integration: StreamingIntegration) =>
              deleteIntegrationModal(integration),
          },
        ]}
      />
    ),
  },
];
